import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ProfileSheetDialogEffects } from './profile-sheet-dialog.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ProfileSheetDialogEffects])],
})
export class ProfileSheetDialogStoreModule {}
